import Vue from 'vue'
import { mapState } from 'vuex'
import $ from 'jquery'

Vue.component('zoom-gallery', {
  props: {
    productTitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      zoomExpanded: false,
      zoomPopup: false
    }
  },
  computed: {
    ...mapState('product', ['product']),
    images () {
      if (!this.product || !this.product.images) return []
      return this.product.images
    }
  },
  mounted () {
    this.zoomPopup = true
    this._onZoomOpen = (e) => this.showZoom(e.detail)
    document.addEventListener('zoom:open', this._onZoomOpen)

  },
  beforeDestroy () {
    document.removeEventListener('zoom:open', this._onZoomOpen)
  },
  methods: {
    onImageClick (e) {
      const img = e.target.closest('img.img__el')
      if (img) {
        const wrapper = img.closest('.img') || img.closest('picture')
        if (wrapper) {
          wrapper.classList.toggle('zoomed')
        }
      }
    },
    closeZoom () {
      this.zoomExpanded = false
      document.body.classList.remove('overflow-hidden')
      $('.zoom-images-gallery').scrollTop(0)
    },
    showZoom (refName) {
      this.zoomExpanded = true
      document.body.classList.add('overflow-hidden')

      this.$nextTick(() => {
        setTimeout(() => {
          if (refName === 'mobile') {
            const index = $('.product-gallery .slick-active').data('slick-index')
            const top = $('#div' + index).position().top
            $('.zoom-images-gallery').scrollTop(top)
          } else {
            const el = document.getElementById(refName)
            if (el) {
              const top = $(el).position().top
              $('.zoom-images-gallery').scrollTop(top)
            }
          }
        }, 100)

      })
    }
  },
  template: `
    <div class="zoom-images-gallery hide"
      :class="{ 'zoom-show': zoomExpanded }"
      v-if="zoomPopup"
      @click="onImageClick">
      <div class="zoom-header">
        <button class="zoom-gallery__close" @click.prevent="closeZoom">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.9999 1L1.2832 20.7166L20.9999 1Z" stroke="black" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M20.7167 20.7166L1 1L20.7167 20.7166Z" stroke="black" stroke-miterlimit="10" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <span v-for="(image, index) in images"
        :key="index"
        :ref="'div' + index"
        :id="'div' + index">
        <vue-image
          :src="image.src"
          :alt="image.alt || productTitle"
          fit="contain"
          pos="center"
          :transparent="false"
          :lazy="true"></vue-image>
      </span>
    </div>
  `
})
